import React from "react";
import { Segmented } from "antd";

const MySegmented = ({ options, value, setValue, disabled }) => {
  return (
    <Segmented
      options={options}
      value={value}
      onChange={setValue}
      disabled={disabled}
    />
  );
};

export default MySegmented;
